import { API } from 'aws-amplify';
import configData from "../components/configFile.json";

class UserGuidService {

    getFileUrl = async (role) => {           

        var myInit = {
            body: {
                Role: role,
                ResourceUrl: configData.signOutUrl
            }
            };
            var ReturnObj = "";
      
            await API.post('IAPI', 'DownloadFile/GetFileURL',myInit)
            .then((res) => {              
               ReturnObj = res.signedUrl;
               return res;
            }).catch((error) => {
               return error;
            }
            );
            return ReturnObj;
    }
  
}
export default new UserGuidService();
